import React from "react";
import styled from "styled-components";
import { Timeline_Detail } from "./Timeline_Detail";
import {
    read_timeline_date_label,
    read_timeline_note_label,
    read_timeline_value_label
} from "../../utils/timeline/timeline_formatting";

const TimelineCalendar = styled.div`
    display: grid;
    gap: 0.6rem;
`;

// Displays the callback schedule that moved the Brand into Stalling.
export const Timeline_Calendar = (props) => {
    return (
        <TimelineCalendar>
            <Timeline_Detail
                label={props.t("Callback")}
                value={read_timeline_date_label(props.event?.data?.schedule || props.event?.to?.schedule || props.event?.to?.meetingDate) || read_timeline_value_label(props.event?.data?.schedule, "")}
            />
            <Timeline_Detail
                label={props.t("Note")}
                value={read_timeline_note_label(props.event)}
            />
        </TimelineCalendar>
    );
};
